import type { JSX, PropsWithChildren } from 'react';

import { DisabledCursorBlocker, Inner, WarningContainer, WarningText, Wrapper } from './styles';
import type { CardProps } from './types';

const Card = ({
	children,
	noPadding = false,
	disabled = false,
	maxWidth,
	innerMaxWidth,
	className,
	warningText,
	ref,
	...props
}: PropsWithChildren<CardProps>): JSX.Element => {
	return (
		<Wrapper
			{...props}
			ref={ref}
			className={className}
			$disabled={disabled}
			aria-disabled={disabled}
			$maxWidth={maxWidth}
		>
			{warningText && (
				<WarningContainer data-testid="warning-container">
					<WarningText>{warningText}</WarningText>
				</WarningContainer>
			)}
			{disabled && <DisabledCursorBlocker />}
			<Inner $noPadding={noPadding} $innerMaxWidth={innerMaxWidth}>
				{children}
			</Inner>
		</Wrapper>
	);
};

export default Card;
